import React, { useState, useEffect } from "react";
import { NAV_ITEMS, HOME, PRIVACY } from "./constants";
import { scrollToId } from "../utils/scroll";
import TextSizeControl from "./TextSizeControl";

function Logo({ onClick }) {
  return (
    <a
      className="brand"
      href="#home"
      onClick={onClick}
    >
      <span className="brand__mark" aria-hidden="true">
        <img src="/images/raf9456logo.png" alt="" />
      </span>
      <span className="brand__text">
        <span className="brand__name">RAF Lodge 9456</span>
        <span className="brand__sub">Warwickshire</span>
      </span>
    </a>
  );
}

function Header({ activeSection, view, onView }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const onLink = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    if (view !== HOME) {
      onView(HOME);
      setTimeout(() => scrollToId(id), 50);
    } else {
      scrollToId(id);
    }
  };

  const onPrivacyClick = (e) => {
    e.preventDefault();
    setOpen(false);
    onView(PRIVACY);
  };

  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <header className="site-header">
        <div className="container nav">
          <Logo onClick={onLink("home")} />
          <nav aria-label="Primary">
            <ul className="nav__links">
              {NAV_ITEMS.map((item) => (
                <li key={item.id}>
                  <a
                    href={"#" + item.id}
                    aria-current={
                      activeSection === item.id && view === HOME ? "page" : undefined
                    }
                    onClick={onLink(item.id)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="nav__tools">
            <TextSizeControl />
          </div>
          <button
            className="burger"
            aria-label="Open menu"
            aria-expanded={open}
            onClick={() => setOpen(true)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </header>

      <div
        className={"drawer-backdrop" + (open ? " open" : "")}
        onClick={() => setOpen(false)}
      />
      <aside
        className={"drawer" + (open ? " open" : "")}
        {...(!open && { inert: "" })}
        aria-label="Mobile navigation"
      >
        <div className="drawer__head">
          <span className="drawer__title">Menu</span>
          <button
            className="drawer__close"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="6" y1="6" x2="18" y2="18" />
              <line x1="18" y1="6" x2="6" y2="18" />
            </svg>
          </button>
        </div>
        <ul className="drawer__links">
          {NAV_ITEMS.map((item) => (
            <li key={item.id}>
              <a href={"#" + item.id} onClick={onLink(item.id)}>
                {item.label}
                <span aria-hidden="true">→</span>
              </a>
            </li>
          ))}
          <li>
            <a href="#privacy" onClick={onPrivacyClick}>
              Privacy <span aria-hidden="true">→</span>
            </a>
          </li>
        </ul>
        <div className="drawer__foot">
          <TextSizeControl />
        </div>
      </aside>
    </>
  );
}

export default Header;
